import { createSlice } from "@reduxjs/toolkit";
import { removeLocalStorageToken, setSessionStorage } from "../../utils/common.util";
import logger from "../../utils/logger";
import apiService from "../../service/apiService";
import { AdminAuth } from "../../apiEndPoints";

const initialState = {
  userData: {},
};
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginAction: (state, action) => {
      return (state = {
        ...state,
        userData: { ...action.payload },
      });
    },
    logoutAction: (state) => {
      return (state = {
        ...state,
        userData: {},
      });
    },
  },
});
export const { logoutAction, loginAction } = authSlice.actions;


export const loginData = (data) => async (dispatch) => {
  try {
    dispatch(loginAction(data));
  } catch (error) {
    logger(error);
  }
};

export const logout = () => async (dispatch) => {
  try {
    dispatch(logoutAction());
    removeLocalStorageToken();
  } catch (error) {
    logger(error);
  }
};


export const fetchProfile = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const userData = state?.auth?.userData;
    if (userData?.id && userData?.type === 'vendor') {
      const res = await apiService(AdminAuth.getVendorProfile(userData.id));
      if (res?.success) {
        let fetchedData = res?.data || {};
        // Flatten personalData if present (Vendor API returns nested structure)
        if (fetchedData?.personalData) {
          fetchedData = { ...fetchedData, ...fetchedData.personalData };
        }
        
        let newData = { ...userData, ...fetchedData };
        // Explicitly ensure active_status is updated if present
        if (fetchedData?.active_status !== undefined) {
          newData.active_status = fetchedData.active_status;
        }

        dispatch(loginAction(newData));
        setSessionStorage("userAuthData", newData);
      }
    }
  } catch (error) {
    logger(error);
  }
};


export const selectUserData = (state) => state.auth.userData;
export const selectUsertype = (state) => state.auth.type;

export default authSlice.reducer;
